import React, { useContext } from "react";
import { FaBars } from "react-icons/fa";
import { useGlobalContext } from "./context";
import "./Sidebar.css";
import { Link } from "react-router-dom";
import { Text } from "../containers/Language";
import logs from "../images/ref.png";

import { languageOptions } from "../languages";
import { LanguageContext } from "../containers/Language";

const Navbar = () => {
  const { openSidebar, openSubmenu, closeSubmenu } = useGlobalContext();
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);
  const displaySubmenu = (e) => {
    const page = e.target.textContent;
    const tempBtn = e.target.getBoundingClientRect();
    const center = (tempBtn.left + tempBtn.right) / 2;
    const bottom = tempBtn.bottom - 3;
    openSubmenu(page, { center, bottom });
  };

  const handleSubmenu = (e) => {
    if (!e.target.classList.contains("link-btn")) {
      closeSubmenu();
    }
  };

  const handleLanguageChange = (e) => userLanguageChange(e.target.value);

  return (
    <nav className="nav" onMouseOver={handleSubmenu}>
      <Link to="/">
        <img src={logs} alt="worldcom" className="header_logo11" />
      </Link>

      <div className="nav-center">
        <div className="nav-header">
          <button className="btn toggle-btn" onClick={openSidebar}>
            <FaBars />
          </button>
        </div>
        <ul className="nav-links">
          <li>
            <button className="link-btn" onMouseOver={displaySubmenu}>
              <Text tid="Welcome_Navbar_info" />
            </button>
          </li>

          <li>
            <button className="link-btn" onMouseOver={displaySubmenu}>
              <Text tid="Welcome_Navbar_courses" />
            </button>
          </li>

          <li>
            <select
              className="link-btn"
              onChange={handleLanguageChange}
              value={userLanguage}
            >
              {Object.entries(languageOptions).map(([id, name]) => (
                <option className="link-btn_1" key={id} value={id}>
                  {name}
                </option>
              ))}
            </select>
          </li>

          <li>
            <button className="link-btn_2">
              <Link to="/login">
                <Text tid="WelcomeSignSec" />
              </Link>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
